<template>
  <div id="other-homepage">
    <template v-if="!confirmedPersonalizations && hasDecorationsConfigurator">
      <Personalizations
        @updatePersonalization="handleConfirmPersonalizations"
      />
    </template>

    <template v-else>
      <ProductsSelection
        @updatePersonalizationsTab="handleUpdatePersonalizationsTab"
      />
    </template>
  </div>
</template>

<script>
import Personalizations from "@/components/Projects/Showrooms/Homepage/Personalizations";
import ProductsSelection from "@/components/Projects/Showrooms/Homepage/ProductsSelection";

export default {
  name: "OtherPath",

  methods: {
    
    hasDecorationsConfigurator() {
      return window.decorationsConfigurator != null
    },

    handleConfirmPersonalizations(bool) {
      this.confirmedPersonalizations = bool;
    },

    //let the parent comp know we are now customizing colors, used for home title
    handleUpdatePersonalizationsTab(tab) {
      this.$emit("personalizationsTabActive", tab);
    },
  },

  mounted() {
    this.handleUpdatePersonalizationsTab("personalizations");
  },

  components: {
    Personalizations,
    ProductsSelection,
  },

  data() {
    return {
      confirmedPersonalizations: false,
    };
  },
};
</script>